import React from "react";
import PropTypes from "prop-types";

import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";

const InfoDialog = props => {
  const { open, content, onDismiss } = props;

  const detailsPanel = () => {
    if (content.details) {
      return <pre>{JSON.stringify(content.details, null, " ")}</pre>;
    }
  };

  return (
    <Dialog open={open} onRequestClose={onDismiss}>
      <DialogTitle>{content.message}</DialogTitle>
      <DialogContent>{detailsPanel(content)}</DialogContent>
      <DialogActions>
        <Button onClick={onDismiss} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoDialog;

InfoDialog.propTypes = {
  content: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/InfoDialog.js